import $ from 'jquery';
import mapboxgl from '!mapbox-gl';

import { fitBounds, getLayerFeatures, getLayerFeaturesByProperty, getMapSettings, map, mapMarkers, getFeaturesBounds, changeLayerFeaturesOpacity } from './main';
import { $Elements, Breakpoints, Classes, Durations, Events } from '../global/constants';
import { wait } from '../global/helpers';

$Elements.document.on('map.initialized', initMarkers);

async function initMarkers() {

	const appellationLayers = ['Medoc', 'Blayais', 'Rive-Droite', 'Entre-Deux-Mers', 'Graves', 'Sauternes'];
	const settings = getMapSettings();

	let appellations = [];
	let initialZoom = 7;

	appellationLayers.forEach(appellation => appellations = [...appellations, ...getLayerFeatures(appellation)]);

	if(appellations.length && settings) {

		const resetMap = async() => {

			if(!map.isMoving()) {

				await fitBounds(getFeaturesBounds(appellations), {
					padding: 20,
				});

				initialZoom = map.getZoom();
			}
		}

		settings.markers.forEach(marker => {

			const entity = getLayerFeaturesByProperty('entities', 'place_name', marker.id);

			if(entity.length && entity[0].geometry.type === 'Point') {

				const mapMarker = $(marker.marker);

				mapMarkers.push(new mapboxgl.Marker({
					element: mapMarker[0],
					anchor: (marker.position) ? marker.position : 'bottom',
				}).setLngLat(entity[0].geometry.coordinates).addTo(map));
			}
		});

		await resetMap();

		//$('.property-marker').addClass(Classes.active);

		$('.reset-entities').on('click', async function() {

		//	$('.property-marker').addClass(Classes.active);
			$('.toggle-entity').removeClass(Classes.active);
			$('.active-marker').empty();

			appellationLayers.forEach(layer => changeLayerFeaturesOpacity(layer, 1));

			if(map.getZoom() > initialZoom) {

				await fitBounds(getFeaturesBounds(appellations), {
					padding: 20,
				});
			}

			if($(this).hasClass('display-chateaux')) {
				$('.property-marker').addClass(Classes.active);
			} else {
				$('.property-marker').removeClass(Classes.active);
			}
		});

		$('.toggle-entity').on('click', async function() {

			if(window.innerWidth < Breakpoints.mobile) {
				$('.active-marker').append($(this).parent().html());
				$('#main-collapse').collapse('hide');
				await wait(Durations.default.ms + 100);
			}

			if(!($(this).hasClass(Classes.active))) {

				const entities = JSON.parse(this.dataset.entities);

				$('.toggle-entity').removeClass(Classes.active);

				// Reset all

				appellationLayers.forEach(layer => changeLayerFeaturesOpacity(layer, 1));

				if(map.getZoom() > initialZoom) {

					//$('.property-marker').addClass(Classes.active);

					await fitBounds(getFeaturesBounds(appellations), {
						padding: 20,
					});
				}

				// Handle markers

				$('.property-marker').removeClass(Classes.active);

				if(Array.isArray(entities.markers) && entities.markers.length) {

					entities.markers.forEach(marker => {
						$('.property-marker[data-entity="' + marker + '"]').addClass(Classes.active);
					});
				}

				// Handle Layers

				let coordinates = [];

				if(Array.isArray(entities.layers) && entities.layers.length) {

					appellationLayers.forEach(layer => changeLayerFeaturesOpacity(layer, 0));

					entities.layers.forEach(layer => {
						changeLayerFeaturesOpacity(layer, 1);
						coordinates = [...coordinates, ...getLayerFeatures(layer)]
					});
				}
				else {
					appellationLayers.forEach(layer => changeLayerFeaturesOpacity(layer, 1));
					coordinates = appellations;
				}

				$(this).addClass(Classes.active);

				await fitBounds(getFeaturesBounds(coordinates), {
					padding: 20,
				});
			}
		});
	}
}
